import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { User, UserPlus, UserMinus } from "lucide-react";
import { getPhotoUrl } from "@/utils/photoUrl";

function TeammateRow({ tm, idx, color }) {
  return (
    <div key={tm.id || idx} className={`flex items-center gap-3 p-2 bg-${color}-500/10 rounded-lg border border-${color}-500/20`}>
      <div className="w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
        {tm.photo_url ? (
          <img src={getPhotoUrl(tm.photo_url)} alt={tm.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center"><User className="h-5 w-5 text-muted-foreground" /></div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium text-foreground truncate">{tm.name}</p>
      </div>
      <Badge className={`bg-${color}-500/20 text-${color}-400 border-0`}>{tm.count}x</Badge>
    </div>
  );
}

export default function TeammatesSection({ teammates, t }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="bg-card/50 border-border/50">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-foreground text-lg">
            <UserPlus className="h-5 w-5 text-green-400" />
            {t("playerDashboard.mostPlayedWith")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {teammates.most_played?.length === 0 ? (
            <p className="text-center text-muted-foreground py-4">{t("common.noData")}</p>
          ) : (
            <div className="space-y-3">
              {teammates.most_played?.map((tm, idx) => (
                <TeammateRow key={tm.id || idx} tm={tm} idx={idx} color="green" />
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="bg-card/50 border-border/50">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-foreground text-lg">
            <UserMinus className="h-5 w-5 text-red-400" />
            {t("playerDashboard.leastPlayedWith")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {teammates.least_played?.length === 0 ? (
            <p className="text-center text-muted-foreground py-4">{t("common.noData")}</p>
          ) : (
            <div className="space-y-3">
              {teammates.least_played?.map((tm, idx) => (
                <TeammateRow key={tm.id || idx} tm={tm} idx={idx} color="red" />
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
